import React from "react";
import { LOGO_URL } from "../lib/brand";

export default function Splash({ onBegin }) {
  return (
    <div className="min-h-screen relative flex flex-col items-center justify-center text-center px-8 overflow-hidden">
      <img
        src="https://images.unsplash.com/photo-1693723876124-2a2d53268d08?w=1400&q=80"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-text/30 via-brand-text/20 to-brand-sand" />
      <div className="relative z-10 mt-auto flex flex-col items-center pb-12 max-w-md">
        <img
          src={LOGO_URL}
          alt="Ozzy"
          className="w-28 h-28 sm:w-32 sm:h-32 rounded-full shadow-xl border-4 border-brand-sand object-cover mb-6"
        />
        <span className="td-section-label text-brand-sand mb-3">United Kingdom</span>
        <h1 className="font-heading text-5xl sm:text-6xl font-semibold text-brand-sand leading-[0.95]">
          TrailDog
        </h1>
        <p className="font-heading italic text-brand-sand/90 text-xl mt-2">Ozzy's Basecamp</p>
        <p className="text-brand-sand/90 mt-5 leading-relaxed">
          Dog-first trails, campsites and weather across the British countryside.
        </p>
        <button
          data-testid="begin-adventure-btn"
          onClick={onBegin}
          className="td-btn-accent mt-8 px-8 py-3.5"
        >
          Begin the adventure
        </button>
      </div>
    </div>
  );
}
